// Sized so UUIDs (36 chars) truncate and shorter human-readable ids are left alone.
const TRUNCATE_LONGER_THAN = 20
const TRUNCATED_LENGTH = 8

/**
 * Shortens a database entity id for display. The full value must stay reachable some other way —
 * a tooltip, an accessible name or the clipboard — since this is lossy.
 */
export function truncateId(value: string): string {
  return value.length > TRUNCATE_LONGER_THAN ? `${value.slice(0, TRUNCATED_LENGTH)}…` : value
}
